import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/hooks/useI18n";

interface RequestsCountCellProps {
  /** Pratiche senza un itinerario ancora pagato, a oggi. */
  activeCount: number;
  /** Pratiche con almeno una rata incassata nel periodo. */
  completedCount: number;
}

/**
 * Le pratiche di una riga in una cella sola: due pill affiancate, ambra e verde.
 *
 * Erano due colonne di numeri nudi, e a occhio si leggevano come due classifiche
 * separate; qui stanno vicine e si leggono per quello che sono, i due stati della stessa
 * pila di lavoro. I colori sono gli stessi che gli stati usano ovunque nell'app -- ambra
 * per cio' che e' aperto, verde per cio' che e' chiuso -- quindi la riga si scansiona
 * senza leggere le parole.
 *
 * Lo zero non sparisce: una pill "0 in corso" e' un'informazione (questo cliente non ha
 * niente di aperto), mentre una cella vuota si leggerebbe come un dato mancante.
 */
export function RequestsCountCell({
  activeCount,
  completedCount,
}: RequestsCountCellProps) {
  const { t } = useI18n();

  return (
    <div className="flex items-center justify-end gap-1.5 whitespace-nowrap">
      <Badge
        variant="outline"
        className="bg-amber-50 text-amber-700 border-amber-200 font-normal tabular-nums"
      >
        {t("dashboard.overview.requests.activePill", { count: activeCount })}
      </Badge>
      <Badge
        variant="outline"
        className="bg-emerald-50 text-emerald-700 border-emerald-200 font-normal tabular-nums"
      >
        {t("dashboard.overview.requests.completedPill", { count: completedCount })}
      </Badge>
    </div>
  );
}

export default RequestsCountCell;
